import { render, staticRenderFns } from "./M_message.vue?vue&type=template&id=4caddd68&scoped=true&"
import script from "./M_message.vue?vue&type=script&lang=js&"
export * from "./M_message.vue?vue&type=script&lang=js&"
import style0 from "./M_message.vue?vue&type=style&index=0&id=4caddd68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caddd68",
  null
  
)

export default component.exports